"use strict";

define('rs/form/formobjects/label/label.formobject',['rs/form/formobjects/base.formobject', 'rs/form/formobjects/label/label.formobject.view'], function (BaseFormObject, LabelFormObjectView) {
  var LabelFormObject = BaseFormObject.extend({
    defaultValue: '',
    propertiesDefinitions: ['name', 'text', 'helpText'],
    linksDefinitions: [],
    isCommentable: function isCommentable() {
      return false;
    },
    setupView: function setupView() {
      this.setView(new LabelFormObjectView());
    },
    canBeLinkedFromFormObject: function canBeLinkedFromFormObject(linker, type) {
      if (!this._super.apply(this, arguments)) {
        return false;
      }
      if (type == "required") {
        return false;
      }
      return true;
    },
    getTemplateProperties: function getTemplateProperties() {
      var props = this._super.apply(this, arguments);
      props.hideLabel = true;
      props.hideDescription = true;
      return props;
    }
  }, {
    getTypeString: function getTypeString() {
      return 'Label';
    }
  });
  return LabelFormObject;
});

